document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('StickyAddToCart');
  if (!stickyBar) return;
  const firstFoldHeight = window.innerHeight;

  window.addEventListener('scroll', () => {
    if (window.scrollY > firstFoldHeight) {
      stickyBar.classList.remove('hidden');
    } else {
      stickyBar.classList.add('hidden');
    }
  });
});